



































import Vue from "vue";
import Component from "vue-class-component";
import { IHeaders } from "./interfaces";
import { targets, maps } from "@/store";
import { IVessel } from "@/store/targets/models";
import { MutationTypes } from "@/store/mutations-types";

@Component
export default class VesselsTable extends Vue {
  search: string = "";
  headers: IHeaders[] = [
    {
      text: "MMSI",
      align: "start",
      sortable: false,
      value: "mmsi",
    },
    { text: "Nombre", value: "statics.name" },
    { text: "CallSign", value: "statics.callsign" },
    { text: "IMO", value: "statics.imo" },
    { text: "Destino", value: "statics.destination" },
    { text: "Tipo de embarcación", value: "statics.shiptype" },
    { text: "Calado (m)", value: "statics.draught" },
    { text: "Velocidad (kn)", value: "speed" },
    { text: "Última actualización", value: "timestamp" },
    { text: "Estado", value: "status" },
  ];

  get vessels() {
    return targets.getters.vesselList;
  }

  handleTimestamp(value: string) {
   return new Date(value).toLocaleTimeString("en-US");
  }

  handleClick(value: IVessel) {
    maps.commit(MutationTypes.SET_MAPCENTER, value.position.coordinates);
    const target: IVessel = targets.getters.searchVesselById(value.mmsi);
    targets.commit(MutationTypes.SET_SELECTED_VESSEL, target);
  }
}
